<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
        };
    },
};
</script>
<style lang='scss'>
@media screen and (max-width: 1200px) {
    .searchA {
        display: block !important;
        .add {
            text-align: left !important;
            margin-left: -10px !important;
            margin-top: 10px !important;
        }
    }
    .list-page-wrap .searchA {
        display: block !important;
        .add {
            text-align: left !important;
            margin-left: -10px !important;
            margin-top: 10px !important;
        }
    }
}
.el-popper {
    max-width: 550px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue